module.exports = __webpack_public_path__ + "static/img/main6_9.99cdaf4e.png";